import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyBeforePrivacy20241201'

const PagePolicyBeforePrivacy20241201 = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforePrivacy20241201
